import { useHistory } from 'react-router-dom';
import {
  Button,
  Fade,
  Grid,
  Hidden,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { usePartner_GetAllPartnersQuery } from 'queries';
import { ChevronRight, Plus } from 'ts-react-feather-icons';

import Spinner from 'common/spinner';
import HomeLayout from 'layouts/home-layout';
import { NotificationSeverity, showAlert } from 'utils/notification-manager';

const useStyles = makeStyles(() => ({
  container: {
    padding: '5%',
    flexGrow: 1,
  },
  title: {
    fontWeight: 600,
  },
  subtitle: {
    color: '#096094',
    width: '100%',
    margin: '2vh',
    float: 'left',
    fontWeight: 600,
  },
  grid: {
    backgroundColor: '#ffffff',
    marginTop: '20px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    height: '100vh',
    padding: '3px',
  },
  button: {
    backgroundColor: '#44D2F2',
    color: '#ffffff',
    float: 'right',
    minWidth: '0',
  },
  tile: {
    margin: '7px',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.25)',
    cursor: 'pointer',
  },
  tilebar: {
    backgroundColor: '#096094',
    display: 'flex',
  },
  list: {
    justifyContent: 'left',
    paddingLeft: '2vw',
    width: '91%',
  },
  parentRoute: {
    color: '#8DA8B2',
    cursor: 'pointer',
  },
  routeIconContainer: {
    verticalAlign: 'middle',
  },
  logo: {
    objectFit: 'scale-down',
    paddingBottom: '50px',
  },
  spinner: {
    height: '40vh',
    margin: 'auto ',
  },
  padding: {
    paddingTop: '15px',
    paddingRight: '5px',
  },
}));

export default function CorporateReferrals() {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const themeBreakpontsUpMd = useMediaQuery(theme.breakpoints.up('md'));

  const { data: partnersData, loading: partnersLoading } = usePartner_GetAllPartnersQuery({
    onError: (e) => {
      showAlert({
        message: 'Error getting all partners: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  return (
    <>
      <HomeLayout showPortalName={false}>
        <Fade in={true}>
          <div className={classes.container}>
            <Typography className={classes.title} variant="h5">
              <span
                className={clsx(classes.parentRoute, classes.routeIconContainer)}
                onClick={() => {
                  history.push(`/home`);
                }}
              >
                <span className={classes.routeIconContainer}>
                  <img src="/home-icon.svg" alt="home-icon" />
                </span>
                <span className={classes.routeIconContainer}>
                  <ChevronRight />
                </span>
              </span>
              Manage Corporate Referrals
            </Typography>
            <Grid className={classes.grid}>
              {partnersData && !partnersLoading ? (
                <div>
                  <Grid container>
                    <Grid xs={9} item md={8} lg={8}>
                      <Typography variant="h5">
                        <div className={classes.subtitle}>Existing Corporate Partners</div>
                      </Typography>
                    </Grid>
                    <Grid xs={3} item md={4} lg={4} className={classes.padding}>
                      <Button
                        className={classes.button}
                        onClick={() => history.push(`/home/new-referral`)}
                      >
                        <Plus /> <Hidden mdDown={true}>Add a New Partner</Hidden>
                      </Button>
                    </Grid>
                  </Grid>
                  <ImageList cols={themeBreakpontsUpMd ? 4.3 : 3} className={classes.list}>
                    {partnersData.data.map((partner) => (
                      <ImageListItem
                        key={partner.name}
                        className={classes.tile}
                        onClick={() => {
                          history.push(`/home/${partner.id}/edit-referral`);
                        }}
                      >
                        <img
                          src={partner.logoUrl || '/default_avatar.svg'}
                          alt="partner-logo"
                          className={classes.logo}
                        />
                        <ImageListItemBar title={partner.name} className={classes.tilebar} />
                      </ImageListItem>
                    ))}
                  </ImageList>
                </div>
              ) : (
                <Spinner className={classes.spinner} />
              )}
            </Grid>
          </div>
        </Fade>
      </HomeLayout>
    </>
  );
}
